
const moduleData = {
  id: "module-11",
  title: "Module 11",
  subtitle: "3D Model Concept Note: The Inverted Peepul Tree (Aśvattha)",
   cardImage: "/enBanner/m11_banner.jpg",
  pdfPath: "/en/Modules/m11.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m11.mp3",
    duration: "0:00"
  },
  video: {
    id: "s-y_2_Q-2_Q"
  },
  hero: {
    title: "Module 11",
    subtitle: "Necessity of Guru in man’s journey to Divinity",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m11_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "3D Model Concept Note",
        title: "What is Necessity of Guru in man’s journey to Divinity?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
         
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
